<template>
    <div>
        <div class="rules-wrapper">
            <div v-for="(rule, index) in rules" :key="index" class="form-group rule-box"
                 style="border: 1px solid #ddd; padding: 10px;">
                <h3 class="form-group">
                    {{ _t("Rule") }} {{ index + 1 }}
                </h3>
                <ShowRule
                    :index="index"
                    :routine-options="routineOptions"
                    :rule-id="rule.id"
                    :routine-id="rule.routine_id"
                    :survey-id="survey_id"
                    @rule-updated="handleRuleUpdated"
                    :is-survey-active="isActive"
                />

                <RuleDefinition
                    v-for="(definition, defIndex) in rule.definitions"
                    :key="defIndex"
                    :questions="questions"
                    :index="defIndex"
                    :rule-id="rule.id"
                    :question_id="definition.question_id"
                    :operator="definition.operator"
                    :selected-answers="definition.selectedAnswers"
                    :input-answer="definition.inputAnswer"
                    :definition-id="definition.id"
                    :survey-id="survey_id"
                    :is-survey-active="isActive"
                    @remove-rule-definition="removeDefinition"
                    @update-rule-definition="loadRules"
                />

                <CreateRuleDefinition
                    :questions="questions"
                    :rule-id="rule.id"
                    :index="index"
                    @add-rule-definition="addDefinition"
                    :is-survey-active="isActive"
                />

                <div class="row">
                    <div class="col-md-12">
                        <button :disabled="isActive" @click="removeRule(rule.id)" class="btn btn-danger float-right">
                            <i class="fa fa-trash"/>
                            <span>{{ _t('Delete rule') }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="form-group col-md-12">
                <div class="form-group">
                    <label for="newRule-routine-id">{{ _t("Routine") }}</label>
                    <select v-model="newRule.routine_id" class="form-control" id="newRule-routine-id">
                        <option value="" selected>{{ _t("Select...") }}</option>
                        <option v-for="(routineLabel, routineId) in routineOptions" :key="routineId"
                                :value="routineId">{{ routineLabel }}
                        </option>
                    </select>
                </div>
                <button :disabled="isActive" @click="addRule" class="btn btn-primary">
                    <i class="fa fa-plus"/>
                    {{ _t("Add rule") }}
                </button>
            </div>
        </div>

    </div>
</template>

<script>
import Swal from 'sweetalert2';
import CreateRuleDefinition from "./CreateRuleDefinition";
import ShowRuleDefinition from "./ShowRuleDefinition";
import ShowRule from "./ShowRule";
import RuleDefinition from "./RuleDefinition";

export default {
    components: {RuleDefinition, ShowRule, ShowRuleDefinition, CreateRuleDefinition},
    props: {
        survey_id: Number,
        routineOptions: Object,
        storeRulesRoute: String,
        indexQuestionsRoute: String,
        isActive: Boolean,
    },
    data() {
        return {
            rules: [],
            questions: [],
            isLoading: false,
            newRule: {
                routine_id: null,
            }
        };
    },
    async created() {
        await this.loadQuestions();
        await this.loadRules();
    },
    methods: {
        addRule() {
            const payload = {...this.newRule}
            if (this.newRule.routine_id === null) {
                Swal.fire(
                    _t("Error"),
                    _t("Routine is required field for each Rule."),
                    "error"
                );
                return;
            }

            axios.post(`/survey/${this.survey_id}/rules`, payload)
                .then((res) => {
                    this.rules = this.mapRules(res.data)
                    this.newRule = {
                        routine_id: null,
                    };

                    Swal.fire({
                        text: _t("Rule added successfully!"),
                        icon: "success",
                        duration: '1000'
                    })
                })
                .catch((err) => {
                    console.log(err)
                    Swal.fire({
                        text: err.response.data.message || 'Something went wrong',
                        icon: "error",
                        duration: '1000'
                    })
                });

        },
        removeRule(ruleId) {

            let that = this;
            Swal.fire({
                text: _t('remove_rule_confirmation-form-label'),
                icon: "warning",
                buttonsStyling: false,
                showCancelButton: true,
                cancelButtonText: _t('Cancel'),
                cancelButtonClass: "btn btn-default",
                confirmButtonText: _t('Yes'),
                confirmButtonClass: "btn btn-success",
            })
                .then(function (result) {
                    if(!result.isConfirmed) return;
                    axios.delete(`/survey/${that.survey_id}/rules/${ruleId}`)
                        .then((res) => {
                            that.rules = that.mapRules(res.data)
                            Swal.fire({
                                text: _t("Rule was removed successfully!"),
                                icon: "success",
                                duration: '1000'
                            })
                        })
                        .catch((err) => {
                            console.log(err)
                            Swal.fire({
                                text: err.response.data.message || 'Something went wrong',
                                icon: "error",
                                duration: '1000'
                            })
                        });
                });


        },
        addDefinition(data) {
            const {ruleId, ruleDefinition} = data;

            axios.post(`/survey/${this.survey_id}/rule/${ruleId}/rule-definition`, ruleDefinition)
                .then((res) => {
                    this.rules = this.mapRules(res.data)
                    Swal.fire({
                        text: _t("Rule definition removed successfully!"),
                        icon: "success",
                        duration: '1000'
                    })
                })
                .catch((err) => {
                    console.log(err)
                    Swal.fire({
                        text: err.response.data.message || 'Something went wrong',
                        icon: "error",
                        duration: '1000'
                    })
                });
        },
        removeDefinition(data) {
            const {ruleId, ruleDefinitionId} = data;
            let that = this;
            Swal.fire({
                text: _t('remove_rule_definition_confirmation-form-label'),
                icon: "warning",
                buttonsStyling: false,
                showCancelButton: true,
                cancelButtonText: _t('Cancel'),
                cancelButtonClass: "btn btn-default",
                confirmButtonText: _t('Yes'),
                confirmButtonClass: "btn btn-success",
            })
                .then(function (result) {
                    if (!result.isConfirmed) return

                    axios.delete(`/survey/${that.survey_id}/rule/${ruleId}/rule-definition/${ruleDefinitionId}`)
                        .then((res) => {
                            that.rules = that.mapRules(res.data)
                            Swal.fire({
                                text: _t("Rule definition removed successfully!"),
                                icon: "success",
                                duration: '1000'
                            })
                        })
                        .catch((err) => {
                            console.log(err)
                            Swal.fire({
                                text: err.response.data.message || 'Something went wrong',
                                icon: "error",
                                duration: '1000'
                            })
                        });
                });

        },
        isAnswerDropdown(questionId) {
            const selectedQuestion = this.questions.find(q => q.id === questionId);
            const isDropdown = selectedQuestion && (selectedQuestion.type === 'single_answer' || selectedQuestion.type === 'multi_answer');

            return isDropdown;
        },
        getAnswers(questionId) {
            const selectedQuestion = this.questions.find(q => q.id === questionId);

            return selectedQuestion ? selectedQuestion.answers : [];
        },
        isMultiAnswer(questionId) {
            const selectedQuestion = this.questions.find(q => q.id === questionId);
            return selectedQuestion && selectedQuestion.type === 'multi_answer';
        },
        isAnswerQuestion(questionId, definitionIndex, ruleIndex) {
            const selectedQuestion = this.questions.find(q => q.id === questionId);

            const isAnswerQuestion = selectedQuestion && (selectedQuestion.tyipe === 'single_answer' || selectedQuestion.type === 'multi_answer');

            if (isAnswerQuestion) {
                this.$set(this.rules[ruleIndex].definitions[definitionIndex], 'operator', 'equals')
            }
            return isAnswerQuestion;
        },
        validateRules() {
            if (this.rules.some(rule => !rule.routine_id)) {
                Swal.fire(this._t("Error"), this._t("Please select a routine for all rules."), "error");
                return false;
            }

            for (const rule of this.rules) {
                for (const definition of rule.definitions) {
                    if (!definition.question_id) {
                        Swal.fire(this._t("Error"), this._t("Please select a question for all rule combinations."), "error");
                        return false;
                    }

                    if (this.isAnswerDropdown(definition.question_id) && definition.selectedAnswers.length === 0) {
                        Swal.fire(this._t("Error"), this._t("Please select at least one answer for rule combinations with a dropdown."), "error");
                        return false;
                    }
                }
            }

            return true;
        },
        submitRules() {
            if (!this.validateRules()) {
                return
            }

            const jsonData = JSON.stringify(this.rules);

            axios.post(this.storeRulesRoute, {rules: this.rules})
                .then((res) => {

                    this.rules = this.mapRules(res.data);
                    Swal.fire({
                        text: _t("Rules updated successfully!"),
                        icon: "success",
                        duration: '1000'
                    })

                    window.location.reload();

                })
                .catch((err) => {
                    Swal.fire({
                        text: err.response.data.message || 'Something went wrong',
                        icon: "error",
                        duration: '1000'
                    })
                });
        },
        mapRules(data) {
            return data.map(item => {
                return {
                    id: item.id,
                    routine_id: item.routine_id,
                    definitions: item.definitions.map(definition => ({
                        id: definition.id,
                        question_id: definition.question_id,
                        operator: definition.operator,
                        selectedAnswers: definition.answer,
                        inputAnswer: definition.answer,
                    })),
                };
            });
        },
        async loadQuestions() {
            this.isLoading = true;
            axios.get(this.indexQuestionsRoute)
                .then((res) => this.questions = res.data)
                .catch((err) => {
                    Swal.fire({
                        text: err.response.data.message || 'Something went wrong',
                        icon: "error",
                        duration: '1000'
                    })
                })
                .finally(() => this.isLoading = false);
        },
        async loadRules() {
            this.isLoading = true;
            axios.get(`/survey/${this.survey_id}/rules`)
                .then((res) => this.rules = this.mapRules(res.data))
                .catch((err) => {
                    Swal.fire({
                        text: err.response.data.message || 'Something went wrong',
                        icon: "error",
                        duration: '1000'
                    })
                })
                .finally(() => this.isLoading = false);
        },
        handleRuleUpdated() {
            this.loadRules();
        }
    },

};
</script>

<style scoped>
/* Add Bootstrap styling here */
</style>



// WEBPACK FOOTER //
// resources/js/app/components/Rules.vue